import axios, {AxiosResponse} from 'axios'
import {ID, WoosatTelecomResponse, Response} from '../../../../../_metronic/helpers'
import {HawalaBranch, HawalaBranchesQueryResponse} from './_models'
import toast from 'react-hot-toast'

const API_URL = process.env.REACT_APP_THEME_API_URL
const HAWALABRANCH_URL = `${API_URL}/admin/hawala-branches`
const GET_HAWALABRANCHES_URL = `${API_URL}/admin/hawala-branches`

const getHawalaBranches = (query: string): Promise<HawalaBranchesQueryResponse |  WoosatTelecomResponse<HawalaBranch[]>> => {
  return axios
    .get(`${GET_HAWALABRANCHES_URL}?${query}`)
    .then((d: AxiosResponse<WoosatTelecomResponse<HawalaBranch[]>>) => {
      return d.data
    })
}

const getHawalaBranchById = async (id: ID): Promise<HawalaBranch> => {
  try {
    const {data} = await axios.get(`${HAWALABRANCH_URL}/${id}`)
    return data?.data?.hawalabranch
  } catch (error: any) {
    console.log('Error: ', error.message)
    return {}
  }
  // return axios.get(`${HAWALABRANCH_URL}/${id}`).then((response: AxiosResponse<HawalaBranch>) => response.data)
}
const createHawalaBranch = (hawala_branch: HawalaBranch): Promise<HawalaBranch | undefined> => {
  return axios
    .post(HAWALABRANCH_URL, hawala_branch)
    .then((response: any) =>
    {if(response.data.success == true){
      toast.success(response.data.message,{position:'top-right'})
    }else{
      toast.error(response?.data?.message,{position:'top-right'})
    }
  return response.data})
    .then((response: Response<HawalaBranch>) => response.data)
}

const updateHawalaBranch = (hawala_branch: HawalaBranch): Promise<HawalaBranch | undefined> => {
  return axios
    .put(`${HAWALABRANCH_URL}/${hawala_branch.id}`, hawala_branch)
    .then((response: any) =>
    {if(response.data.success == true){
      toast.success(response.data.message,{position:'top-right'})
    }else{
      toast.error(response?.data?.message,{position:'top-right'})
    }
  return response.data})
    .then((response: Response<HawalaBranch>) => response.data)
}

const deleteHawalaBranch = (hawala_branchId: ID): Promise<void> => {
  return axios.delete(`${HAWALABRANCH_URL}/${hawala_branchId}`).then((response) => {
    if(response.data.success == true){
      toast.success(response?.data?.message,{position:'top-right'})
    }else{
      toast.error(response?.data?.message,{position:'top-right'})
    }
  })
}

const deleteSelectedHawalaBranches = (hawala_branchIds: Array<ID>): Promise<void> => {
  const requests = hawala_branchIds.map((id) => axios.delete(`${HAWALABRANCH_URL}/${id}`))
  return axios.all(requests).then(() => {
    toast.success('Action completed',{position:'top-right'})
  })
}

export {
  getHawalaBranches,
  deleteHawalaBranch,
  deleteSelectedHawalaBranches,
  getHawalaBranchById,
  createHawalaBranch,
  updateHawalaBranch,
}
